import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrl: './action-buttons.component.scss'
})
export class ActionButtonsComponent {

  @Input() showDiscard:boolean = true
  @Input() showSubmit:boolean = true
  @Input() isSubmitDisabled:boolean = false
  @Input() isDiscardDisabled:boolean = false
  @Input() isSubmitLoading:boolean = false
  @Input() searchLabel:string = 'Common.Search'
  @Input() discardLabel:string = 'Common.Discard'

  @Output() onSubmit: EventEmitter<any> = new EventEmitter();
  @Output() onDiscard: EventEmitter<any> = new EventEmitter();


  search(){
    this.onSubmit.emit()  
  }
  
  discard(){
    this.onDiscard.emit()  
  }

}
